import React, { useState, useEffect } from "react";
import firstimg from '../img/spinoffimg/firstimg.png';
import secondimg from '../img/spinoffimg/secondimg.png';
import thiredimg from '../img/spinoffimg/thiredimg.png';
import fourimg from '../img/spinoffimg/fourimg.png';
import fiveimg from '../img/spinoffimg/fiveimg.png';
import siximg from '../img/spinoffimg/siximg.png';
import sevenimg from '../img/spinoffimg/sevenimg.png';
import eightimg from '../img/spinoffimg/eightimg.png';
import nineimg from '../img/spinoffimg/nineimg.png';
import tenimg from '../img/spinoffimg/tenimg.png';
import elavenimg from '../img/spinoffimg/elavenimg.png';
import twelimg from '../img/spinoffimg/twelimg.png';
import thirteeimg from '../img/spinoffimg/thirteeimg.png';
import thirteenimg from '../img/spinoffimg/thirteenimg.png';
import fourteenimg from '../img/spinoffimg/fourteenimg.png';
import fifteenimg from '../img/spinoffimg/fifteenimg.png';
import sixteenimg from '../img/spinoffimg/sixteenimg.png';
import seventeenimg from '../img/spinoffimg/seventeenimg.png';
import eighteenimg from '../img/spinoffimg/eighteenimg.png';
import nineteenimg from '../img/spinoffimg/nineteenimg.png';
import twenteenimg from '../img/spinoffimg/twenteenimg.png';
import twintyoneimg from '../img/spinoffimg/twintyoneimg.png';
import twintytwoimg from '../img/spinoffimg/twintytwoimg.png';
import twintythreeimg from '../img/spinoffimg/twintythreeimg.png';
import twintyfourimg from '../img/spinoffimg/twintyfourimg.png';
import twintyfiveimg from '../img/spinoffimg/twintyfiveimg.png';
import twintysiximg from '../img/spinoffimg/twintysiximg.png';
import twintyseven from '../img/spinoffimg/twintyseven.png';
import twintyeightimg from '../img/spinoffimg/twintyeightimg.png';
import twintynineimg from '../img/spinoffimg/twintynineimg.png';
import thirtyimg from '../img/spinoffimg/thirteenimg.png';
import thirtyoneimg from '../img/spinoffimg/thirteeoneimg.png';
import thirtytwoimg from '../img/spinoffimg/thirteetwoimg.png';
import thirtythreeimg from '../img/spinoffimg/thirteethreeimg.png';
import thirtyfourimg from '../img/spinoffimg/thirteefourimg.png';
import thirtyfiveimg from '../img/spinoffimg/thirteefiveimg.png';
import thirtysiximg from '../img/spinoffimg/thirteesiximg.png';
import thirtysevenimg from '../img/spinoffimg/thirtysevenimg.png';
import thirtyeightimg from '../img/spinoffimg/backuptwo.png';
import thirtynineimg from '../img/spinoffimg/thirtynineimg.png';
import fourteeimg from '../img/spinoffimg/fourteeimg.png';
import fourtyoneimg from '../img/spinoffimg/fourteeoneimg.png';
import fourtytwoimg from '../img/spinoffimg/fourteetwoimg.png';
import fourtythreeimg from '../img/spinoffimg/fourteethreeimg.png';
import fourtyfourimg from '../img/spinoffimg/fourtyfourimg.png';
import fourtyfiveimg from '../img/spinoffimg/fourteefive.png';
import manfact1 from '../img/spinoffimg/manfact-1.jpg';
import manfact2 from '../img/spinoffimg/manfact-2.jpg';
import manfact3 from '../img/spinoffimg/manfact-3.jpg';
import manfact4 from '../img/spinoffimg/manfact-4.jpg';
import { Helmet } from "react-helmet";
import {
  Factory,
  Battery,
  Globe,
  Award,
  Import,
} from "lucide-react";
import "./Ourjourney.css";

const Ourjourney = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className={`journey-container ${isVisible ? "is-ready" : ""}`}>
      <Helmet>
        <title>Our Infrastructure & Assets | Spinoff Technopark Ltd</title>
        <meta
          name="description"
          content="Mohali LED Manufacturing Facility and Rajpura Lithium Energy Mega Hub - Complete details of Spinoff's assets and technological strength."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="journey-hero">
        <div className="journey-hero-inner">
          <div className="year-badge">
            <Globe size={14} style={{ marginRight: "8px", verticalAlign: "middle" }} />
            OUR STRENGTH
          </div>
          <h1>
            Manufacturing <span className="highlight-gradient">Excellence</span>
          </h1>
          <p>
            Two world-class facilities with deep vertical integration, massive scalability, 
            and cutting-edge technology in LED Lighting and Lithium Energy Storage Systems.
          </p>
          
        </div>
      </section>

      {/* ====================== MOHALI FACTORY ====================== */}
      <section className="facility-section mohali-section">
        <div className="max-w">
          <div className="section-header">
            <Factory size={48} color="#6366f1" />
            <div>
              <div className="year-badge" style={{marginBottom: '16px'}}>MOHALI CAMPUS</div>
              <h2 style={{fontSize:'40px'}}>Mohali Factory – LED Lighting Hub</h2>
            </div>
          </div>

          <div className="facility-content">
            <p>
              Mohali Factory being the 1st factory of Spinoff is located in IT Park – Phase 8, Mohali, Punjab (Chandigarh) 
              with plot size about 1000 sq yards, with Italian marble facility, more than 23,000 sq feet carpet area, 
              6 floors centrally AC building with all modern infrastructure.
            </p>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '32px'}}>
              <img src={firstimg} alt="Mohali Factory" style={{borderRadius: '20px', height: '250px', objectFit: 'cover'}} />
              <img src={secondimg} alt="Mohali Factory" style={{borderRadius: '20px', height: '250px', objectFit: 'cover'}} />
              <img src={thiredimg} alt="Mohali Factory" style={{borderRadius: '20px', height: '250px', objectFit: 'cover'}} />
             
            </div>
            
            <p>
              This facility is used for Design/R&amp;D/Production of LED lights with current manufacturing capacity 
              of <strong>2.5 lakh SMD component mounting per day</strong> on 24×7 basis.
            </p>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '32px'}}>
               <img src={fiveimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
                <img src={siximg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
              <img src={sevenimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
              <img src={eightimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={tenimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={elavenimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={manfact2} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={manfact3} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={manfact4} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
              <img src={twelimg} alt="Mohali Factory" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
             <img src={thirteenimg} alt="Sheet Metal Facility" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            </div>

            <p>
              This facility is being used for all kinds of R&amp;D, New Product Development, making PCB, designing circuit, 
              testing, SMT line and fully integrated in-house facility for production of LED drivers, SMPS, PCB, 
              mounting on SMT and TH, and assembling of lights, may it be from any segment. 
              In the same building we also have the assembling line for different kinds of lighting.
            </p>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px'}}>
             
             <img src={nineimg} alt="Mohali Factory" style={{borderRadius: '12px', height: '180px', objectFit: 'cover'}} />
              <img src={manfact1} alt="Mohali Factory" style={{borderRadius: '12px', height: '180px', objectFit: 'cover'}} />
             
              <img src={fifteenimg} alt="Mohali Factory" style={{borderRadius: '12px', height: '180px', objectFit: 'cover'}} />
             
              <img src={seventeenimg} alt="Mohali Factory" style={{borderRadius: '12px', height: '180px', objectFit: 'cover'}} />
              <img src={eighteenimg} alt="Mohali Factory" style={{borderRadius: '12px', height: '180px', objectFit: 'cover'}} />


            </div>

            <h3>Product Range</h3>
            <p>
              Combination of indoor and outdoor lighting products used in various applications in 
              HOME / OFFICE / PROJECTS / INDUSTRY and customised &amp; specialised lighting such as:
            </p>
            
            <div style={{margin: '24px 0'}}>
              <img src={nineteenimg} alt="Product Range" style={{borderRadius: '24px', marginBottom: '24px', maxHeight: '400px', objectFit: 'cover'}} />
            </div>
            
            <ul className="product-list">
              <li>Ceiling lights, Focus lights, Track lights, Spot lights, Theme lights, Smart lights, Project lights</li>
              <li>Pharma lights, Clean room lights, Street lights, High bay lights, Flood lights</li>
              <li>Decorative lights, Chandelier, Wall lights, Pendant lights, Table lamps, Floor lamps</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ====================== RAJPURA FACTORY ====================== */}
      <section className="facility-section rajpura-section">
        <div className="max-w">
          <div className="section-header">
            <Battery size={48} color="#22c55e" />
            <div>
              <div className="year-badge" style={{marginBottom: '16px'}}>RAJPURA MEGA HUB</div>
              <h2 style={{fontSize:'40px'}}>Rajpura Factory – Lithium Energy Mega Hub</h2>
            </div>
          </div>

          <div className="facility-content">
            <p>
              Rajpura Factory is the second factory, built post COVID in 2022, in Punjab on land pre-owned since more than 20 years by Spinoff. 
              It is located on National Highway, Delhi-Ludhiana Road, with most prime location on NH, having face on more than 8 lane 
              and 200 feet wide road, with slip road in front of factory gate, and huge parking and trucking space in front.
            </p>
            
            <div style={{margin: '32px 0'}}>
              <img src={twenteenimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
            </div>
            
            <p>
              Factory own land along with 10 feet boundary wall plus fencing on all 4 sides is having more than <strong>24,150 sq. yards</strong> plot size, 
              under approved industrial use.
            </p>

            <p>
              This factory has integrated facility to manufacture Home ESS system comprising of Lithium Batteries, Inverter/UPS, SERVO system with full 
              integrated facility. This facility has been recently upgraded to enhance production capacity upto 3GW for lithium storage system (ESS).
            </p>

            <p>
              this facility is supported with  testing/module testing and ageing and high voltage DC testing facility in house of BESS up to size of 1500 kW. 
              The plant  have all state-of-the-art R&amp;D testing, production QC process, and simulation on solar, and testing DC Voltage upto 1500 V DC 
              — the first of its kind facility in this region with focus on in-house R&amp;D for consistent new product development.
            </p>
            
          

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '32px'}}>
              <img src={twintyoneimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
              <img src={twintytwoimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
              <img src={twintythreeimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
              <img src={twintyfourimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
              <img src={twintyfiveimg} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
             
              <img src={twintyseven} alt="Rajpura Factory" style={{borderRadius: '16px', height: '420px', objectFit: 'cover'}} />
             <img src={twintyeightimg} alt="Sheet Metal Facility" style={{borderRadius: '16px', height: '440px', objectFit: 'cover'}} />
              <img src={twintynineimg} alt="Sheet Metal Facility" style={{borderRadius: '16px', height: '440px', objectFit: 'cover'}} />
            </div>
            
            <p>
              To support this facility, a sizeable investment is made in infra and production capacity for ancillary production facility:
            </p>


            
            <div >
              <h4>
                <span style={{fontSize: '20px'}}>🏭</span> Sheet Metal Ancillary Unit
              </h4>
              <p >
                For every ESS and battery packs, a lot of dependency is there on 3rd party to supplies in time, steel cabinet or enclosure made out of different specs of sheet metal, as per needed design and with technical support of product design and prototype of NPD, which is a pain point for every one who is in this business, so we decided to have captive plant for sheet metal to process MS/SS sheet metal up to 4mm thickness keeping in mind the needs of cabinet/enclosure for home ESS to BESS, it helps in time inventory and production support without any additional cost in packing, loading, unloading and transportation, and now this facility is fully functional and a great support of mix product range and fully occupied for single shift support cabinet with full automatic CNC driven machine to process about 400 Mts of SS/MS on per month basis, in 24x7.
              </p>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '32px'}}>
                <img src={thirteeimg} alt="Sheet Metal Facility" style={{borderRadius: '16px', height: '240px', objectFit: 'cover'}} />
                <img src={thirtyoneimg} alt="Sheet Metal Facility" style={{borderRadius: '16px', height: '240px', objectFit: 'cover'}} />
              </div>
            </div>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px', marginBottom: '32px'}}>
             
            </div>
            <div >
              <h4 >
                <span style={{fontSize: '20px'}}>🔋</span> Plastic Injection Moulding Division
              </h4>
              <p >
                In addition to this ancillary unit inside Rajpura factory, we have also created a further facility for making plastic enclosure for smaller lithium batteries product which also has lot of market in product range 12v-5Amp to 100Amp.
              </p>
              <p >
               As we noticed that china has switched to lithium batteries and minimising  use of traditional batteries majorly LA/ VRLA/Gel  in all low voltage batteries , so there is needed to be future ready for a complete change in various application such as Agriculture spray pumps ( estimated annual market size of more then one crore pcs per year in product range of less then 1500/- per pcs, of 12v 5amp-8Amp, and Desktop  UPS with power back up of 10-15 minutes in VRLA , now getting converted in Lithium packs range 12v-10Amp to 20Amp about,  and solar application , and medical and blood testing laboratory application , small online –off line UPS application, all this needs batteries which comes in plastic format, so we have created this facility with in house Injection moulding machine plant , fully supported with in house CNC, VMC Machine to make mould of various type, to eliminate the dependence on 3rd party as supplier, as it eliminate lot of steps, like frequent trials and logistics inconvenience of handling moulds development and trial cycle, as mould weight ranges from 400 kg t0 4000kg as per size, and also because lot of cost and time will be saved, when we achieve scale of operation by full eco cycle for the scale of economies, which is surely needed to be captured, and abundance opportunities lies across the domestic economies, besides global market in this plastic pack  for lithium battery.
              </p>
              <p>Plastic boxes for various sizes as per market trend is now having full facility from mould making machinery to plastic box/component making machinery supporting both business vertical lithium batteries, led driver, led enclosure, and other plastic components, for bulk. This new start up division is now fully used for making moulds and components for making aggressive launch in near future for lithium batteries duly packed and sold in plastic container.</p>
            </div>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginBottom: '32px'}}>
              <img src={thirtythreeimg} alt="Plastic Moulding" style={{borderRadius: '16px', height: '490px', objectFit: 'cover'}} />
            </div>
            
            <div>
              <h4>
                <span>🔧</span> Tool Room & R&D Facility
              </h4>
              <p >
                To support all this plastic and other engineering needs connected with lithium, we made a full scale tool room for making moulds and dies and various product development operation connected with lithium and led business. This may be in initial phase, but we have already made more then 10 mould of different products for captive consumption and also planning to explore this division as independent cost and profit centre in near future to work for others on OEM basis, for their mould making and component making business.
              </p>
            </div>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginBottom: '32px'}}>
              <img src={thirtyfiveimg} alt="Tool Room" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={thirtyfourimg} alt="Tool Room" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={thirtysiximg} alt="Tool Room" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            <img src={thirtythreeimg} alt="Tool Room" style={{borderRadius: '16px', height: '200px', objectFit: 'cover'}} />
            </div>
            
            <div>
              <h4>
                <span>⚡</span> Utilities & Power Infrastructure
              </h4>
              <p >
                The facility has HT line from GRID for 400kva connection and have Transformer of 500kva, and solar power connection of 50kw, along with DG set capacity of 100kw appx, and UPS and other ESS back up of more then 200kw in house, with more then 50kw solar on rooftop.
              </p>
            </div>
            
            <img src={thirtysevenimg} alt="Power Infrastructure" style={{borderRadius: '24px', width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '32px'}} />
            
            <h3>Product Range and Lithium Solutions</h3>
            <p>
              Company Spinoff has spent more then 5 years in R&D and NPD phase, and has achieved satisfactory performance in following products:
            </p>
            
            <div style={{display: 'grid', gap: '24px', marginBottom: '32px',textAlign:'left'}}>
              <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #6366f1'}}>
                <h4 style={{color: '#1e293b', marginBottom: '12px'}}>🏠 Home ESS Division</h4>
                <p style={{color: '#475569', lineHeight: '1.6', marginBottom: '12px'}}>
                 Home ESS Division from1kw to 5kw lithium integrated ESS solution, 
                </p>
                <p>
                   This product is hot selling product and has price range from 20k to 100k per pc, and is being widely used by majority of  homes and offices, irrespective of state/city/town and village. Spinoff has worked on PCB level on same, with in house SMT and integration and full scale production, QC, Testing and R&D Facility to reach to 100 units per day.
                </p>
              </div>
              
              <img src={thirtyeightimg} alt="Home ESS" style={{borderRadius: '16px', width: '100%', objectFit: 'cover',height:'450px'}} />
              
              <div >
                <h4 >Only Lithium batteries (Replacement market for old LA/VRLA/GEL) with old inverter/UPS</h4>
                <p >
                  this market is having annual market size of more then 10000 crores in replacement of lead battery to lithium battery alone, in 12v segment , so it has great potential.</p>
                <p >
                 The new facility of production is being scaled to meet the demand for producing battery packs in this segment of ESS on daily basis of about 100-200 units per day of stand alone batteries, ESS with High Voltage/Low Voltage Options.
                </p>
              </div>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginBottom: '24px'}}>
                <img src={fourteeimg} alt="Lithium Batteries" style={{borderRadius: '12px', height: '200px', objectFit: 'cover',height:'550px'}} />
                <img src={thirtynineimg} alt="Lithium Batteries" style={{borderRadius: '12px', height: '200px', objectFit: 'cover',height:'550px'}} />
              </div>
              
              <div>
                <h4>Lithium batteries  for Agricultural spray pumps, for desktop, for small electric gadget etc in 12v -5Amp to 15Amp </h4>
                <p>
                This is another segment which is short cycle life product traditionally being dominated by LA/VRLA/GEL, with 12v- 6Ah/8Ah/9Ah/10Ah/12Ah/15Ah, the product life varies from 6 month to 24 months, and new Lithium battery will surely eat away this complete share of about 10 million packs a  year with price range 700/- to 2000/-, with average price of say 800/- as small pack is 70% sales, so this section is fully ready and every thing in house to produce 1000 units per day.</p>
              </div>
              <div >
                <h4>🏭 Industrial & Telecom Solutions</h4>
                <p>
                  Spinoff has also learned to make products and launched various other products such as 2w/3w/auto batteries/Telecom batteries and ESS more than 5kw. We also have experience in doing high voltage lithium ESS for industries and commercial projects up to 128kw of ESS packs.
                </p>
                <p>
                  We are preparing ourselves for higher capacity of 1MW project under BESS, for which new machine for production and R&D based test machine is already purchased, will be commissioned in next 2-3 months.
                </p>
                <p >
                  Lithium ESS up to 200kw (solar/non-solar) • 75% of small scale industry load • Ready for launch
                </p>
              </div>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px'}}>
                <img src={fourtyfourimg} alt="Industrial Solutions" style={{borderRadius: '12px', height: '200px', objectFit: 'cover'}} />
                <img src={fourtyfiveimg} alt="Industrial Solutions" style={{borderRadius: '12px', height: '200px', objectFit: 'cover'}} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourjourney;